import React from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';

export default function Footer() {
  const site = process.env.REACT_APP_SITE || 'https://app.signetrisk.com';
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo">
            <img alt="SignetRisk" src="assets/logo-color-4.png" />
          </Link>
          <p className="site-footer__tagline">
            Cyber risk intelligence for MSPs, brokers, and underwriters —
            from fast assessments to quantified exposure.
          </p>
          <a className="site-footer__cta" href={`${site}/signup`}>
            Get started
          </a>
        </div>

        <div className="site-footer__columns">
          <div className="site-footer__column">
            <h3>Product</h3>
            <Link to="/solutions">Solutions</Link>
            <Link to="/pricing">Pricing</Link>
            <a href={`${site}/login`}>Login</a>
            <a href={`${site}/signup`}>Signup</a>
          </div>

          <div className="site-footer__column">
            <h3>Company</h3>
            <Link to="/about">About</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/privacy">Privacy</Link>
            <a href="assets/SignetRisk-TermsConditions.pdf" target="_blank" rel="noreferrer">
              Terms
            </a>
          </div>

          <div className="site-footer__column">
            <h3>Contact</h3>
            <a href="mailto:support@signetrisk.com">support@signetrisk.com</a>
            <a href="https://www.signetrisk.com" target="_blank" rel="noreferrer">
              www.signetrisk.com
            </a>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container site-footer__bottom-inner">
          <p>Copyright &copy; {year} SignetRisk Analytics, Inc.</p>
          <div className="site-footer__legal">
            <Link to="/privacy">Privacy</Link>
            <span aria-hidden="true">·</span>
            <a href="assets/SignetRisk-TermsConditions.pdf" target="_blank" rel="noreferrer">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
